export default __webpack_public_path__ + "static/media/imagen1.9f9f3f06.svg";